import { ReactNode } from 'react';

import './TableLayout.scss';

export type TableLayoutProps = {
    children: ReactNode;
};

export const TableLayout = ({ children }: TableLayoutProps) => <div className="table-layout">{children}</div>;
